import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailCompose from "../pages/Email/email-compose"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//Charts
import ChartsAppex from "../pages/Charts/charts-appex"
import ChartsJs from "../pages/Charts/charts-chartjs"
import ChartsKnob from "../pages/Charts/charts-knob"
import ChartsSparkLine from "../pages/Charts/charts-sparkline"

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"

//Icons
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
import Iconion from "../pages/Icons/Iconion"
import IconFontawesome from "../pages/Icons/IconFontawesome"
import IconThemify from "../pages/Icons/IconThemify"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconTypicons from "../pages/Icons/IconTypicons"

//Tables
import BasicTables from "../pages/Tables/BasicTables"
import DatatableTables from "../pages/Tables/DatatableTables"
import ResponsiveTables from "../pages/Tables/ResponsiveTables"

// Forms
import FormElements from "../pages/Forms/FormElements"
import FormAdvanced from "../pages/Forms/FormAdvanced"
import FormEditors from "../pages/Forms/FormEditors"
import FormValidations from "../pages/Forms/FormValidations"
import FormUpload from "../pages/Forms/FormUpload"

//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiBadge from "../pages/Ui/UiBadge"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiPagination from "../pages/Ui/UiPagination"
import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
import UiProgressbar from "../pages/Ui/UiProgressbar"


//Extra Pages

import Pages404 from "../pages/Extra Pages/pages-404"
import Pages500 from "../pages/Extra Pages/pages-500"

import UniversityList from "pages/University/UniversityList/UniversityList"
import AddUniversity from "pages/University/AddUniversity/AddUniversity"
import InstitutionDataTable from "pages/Institution/InstitutionDataTable/InstitutionDataTable"
import AddInstitution from "pages/Institution/AddInstitution/AddInstitution"

import CourseList from "pages/Courses/CoursesList/CourseList"
import ProgramList from "pages/Program/ProrgamList/ProgramList"
import ViewUniversity from "pages/University/ViewUniversity/ViewUniversity"
import EditUniversity from "pages/University/EditUniversity/EditUniversity"
import ViewInstitution from "pages/Institution/ViewInstitution/ViewInstitution"
import EditInstitution from "pages/Institution/EditInstitution/EditInstitution"
import AddProgram from "pages/Program/AddProgram/AddProgram"
import AddCourse from "pages/Courses/AddCourses/AddCourse"
import EditCourse from "pages/Courses/EditCourse/EditCourse"
import ViewProgram from "pages/Program/ViewProgram/ViewProgram"
import ViewCourse from "pages/Courses/ViewCourse/ViewCourse"
import Categorytable from "pages/Category/CategoryTable/Categorytable"
import AddCategory from "pages/Category/AddCategory/AddCategory"
import ViewCategory from "pages/Category/ViewCategory/ViewCategory"
import EditCategory from "pages/Category/EditCategory/EditCategory"
import EditProgram from "pages/Program/EditProgram/EditProgram"
import UserList from "pages/Users/UsersList/UserList"
import Tasklist from "pages/Task/TaskList/taskList"
import AssignTask from "pages/Task/AssignTask/assignTask"
import EditTask from "pages/Task/EditTask/EditTask"
import TaskDataTable from "pages/Task/Analyst/TaskDataTable/TaskDataTable"
import ViewTask from "pages/Task/Analyst/ViewTask/viewTask"
import IntrestedCandidates from "pages/IntrestedCandidates/IntrestedCandidates"
import ListNewsAndArticles from "pages/NewsAndArticles/ListNewsAndArticles/ListNewsAndArticles"
import ViewArticle from "pages/NewsAndArticles/ViewNewsAndArticles/ViewArticle"
import AddNewsAndArticle from "pages/NewsAndArticles/AddNewsAndArticles/AddNewsAndArticle"
import EditNewsAndArticle from "pages/NewsAndArticles/EditNewsAndArticle/EditNewsAndArticle"
import SeoDataTable from "pages/Seo/SeoDataTable/SeoDataTable"
import AddSeo from "pages/Seo/AddSeo/AddSeo"
import ViewSeo from "pages/Seo/ViewSeo/ViewSeo"
import EditSeo from "pages/Seo/EditSeo/EditSeo"
import CommonCourseList from "pages/CommonCourses/CommonCourseList/CommonCourseList"
import AddCommonCourse from "pages/CommonCourses/AddCommonCourse/AddCommonCourse"
import ViewCommonCourse from "pages/CommonCourses/ViewCommonCourse/ViewCommonCourse"
import EditCommonCourse from "pages/CommonCourses/EditCommonCourse/EditCommonCourse"
import CollegeApplicationList from "pages/CollegeApplications/CollegeApplicationList/CollegeApplicationList"
import CountryPreferences from "pages/CountryPreferences/CountryPreferences"
import StatePreferences from "pages/StatePreferences/StatePreferences"
import EmailTemplateDataTable from "pages/EmailTemplate/EmailTemplateTable/EmailTemplateTable"
import AppAddEmailTemplate from "pages/EmailTemplate/AppAddEmailTemplate/AddEmailTemplate"
import EditEmailTemplate from "pages/EmailTemplate/AppEditEmailTemplate/EditEmailTemplate"
import SiteConfig from "pages/SiteConfig/SiteConfig"

// Policy
import Policy from "pages/Policy/Policy"
import AddPolicy from "pages/Policy/AddPolicy"
import EditPolicy from "pages/Policy/EditPolicy"
import ViewPolicy from "pages/Policy/ViewPolicy"

// School
import SchoolDataTable from "pages/School/SchoolDataTable/SchoolDataTable"
import AddSchool from "pages/School/AddSchool/AddSchool"
import EditSchool from "pages/School/EditSchool/EditSchool"
import ViewSchool from "pages/School/ViewSchool/ViewSchool"

// Data Completion
import DataCompletionDashboard from "pages/DataCompletion/DataCompletionDashboard/DataCompletionDashboard"

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //calendar
  // { path: "/calendar", component: <Calendar /> },

  // { path: "/chat", component: <Chat /> },
  // { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  // //Email
  // { path: "/email-inbox", component: <EmailInbox /> },
  // { path: "/email-read", component: <EmailRead /> },
  // { path: "/email-compose", component: <EmailCompose /> },

  // //Charts
  // { path: "/apex-charts", component: <ChartsAppex /> },
  // { path: "/charts-chartjs", component: <ChartsJs /> },
  // { path: "/charts-knob", component: <ChartsKnob /> },
  // { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // Icons
  // { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  // { path: "/icons-ion", component: <Iconion /> },
  // { path: "/icons-fontawesome", component: <IconFontawesome /> },
  // { path: "/icons-themify", component: <IconThemify /> },
  // { path: "/icons-dripicons", component: <IconDripicons /> },
  // { path: "/icons-typicons", component: <IconTypicons /> },

  // // Tables
  // { path: "/tables-basic", component: <BasicTables /> },
  // { path: "/tables-datatable", component: <DatatableTables /> },
  // { path: "/tables-responsive", component: <ResponsiveTables /> },

  // // Maps
  // { path: "/maps-google", component: <MapsGoogle /> },
  // { path: "/maps-vector", component: <MapsVector /> },

  // // Forms
  // { path: "/form-elements", component: <FormElements /> },
  // { path: "/form-advanced", component: <FormAdvanced /> },
  // { path: "/form-editors", component: <FormEditors /> },
  // { path: "/form-uploads", component: <FormUpload /> },
  // { path: "/form-validation", component: <FormValidations /> },

  // // Ui
  // { path: "/ui-alerts", component: <UiAlert /> },
  // { path: "/ui-buttons", component: <UiButtons /> },
  // { path: "/ui-badge", component: <UiBadge /> },
  // { path: "/ui-cards", component: <UiCards /> },
  // { path: "/ui-carousel", component: <UiCarousel /> },
  // { path: "/ui-dropdowns", component: <UiDropdown /> },
  // { path: "/ui-grid", component: <UiGrid /> },
  // { path: "/ui-images", component: <UiImages /> },
  // { path: "/ui-lightbox", component: <UiLightbox /> },
  // { path: "/ui-modals", component: <UiModal /> },
  // { path: "/ui-pagination", component: <UiPagination /> },
  // { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  // { path: "/ui-progressbars", component: <UiProgressbar /> },
  // { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  // { path: "/ui-typography", component: <UiTypography /> },
  // { path: "/ui-video", component: <UiVideo /> },
  // { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  // { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  // { path: "/ui-utilities", component: <UiUtilities /> },
  // { path: "/ui-colors", component: <UiColors /> },
  // { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // //Extra Pages
  // { path: "/pages-timeline", component: <PagesTimeline /> },
  // { path: "/pages-invoice", component: <PagesInvoice /> },
  // { path: "/pages-directory", component: <PagesDirectory /> },
  // { path: "/pages-blank", component: <PagesBlank /> },

  // //University
  { path: "/user-list", component: <UserList /> },

  // //University
  { path: "/universitylist", component: <UniversityList /> },
  { path: "/addUniversity", component: <AddUniversity /> },
  { path: "/edit-university/:universityCode", component: <EditUniversity /> },
  { path: "/view-university/:universityCode", component: <ViewUniversity /> },

  // //Institution
  { path: "/institutionList", component: <InstitutionDataTable /> },
  { path: "/addInstituion", component: <AddInstitution /> },
  {
    path: "/edit-institution/:institutionCode",
    component: <EditInstitution />,
  },
  {
    path: "/view-institution/:institutionCode",
    component: <ViewInstitution />,
  },

  // Data Completion Dashboard
  { path: "/data-completion", component: <DataCompletionDashboard /> },
  // Redirect old route to new route for backward compatibility
  { path: "/data-completion-dashboard", component: <Navigate to="/data-completion" replace /> },

  // //Categioy
  { path: "/categoryList", component: <Categorytable /> },
  { path: "/add-category", component: <AddCategory /> },
  { path: "/edit-category/:categoryCode", component: <EditCategory /> },
  { path: "/view-category/:categoryCode", component: <ViewCategory /> },

  // //Prorgam
  { path: "/programList", component: <ProgramList /> },
  { path: "/addProgram", component: <AddProgram /> },
  { path: "/edit-program/:programId", component: <EditProgram /> },
  { path: "/view-program/:programId", component: <ViewProgram /> },

  // //Course
  { path: "/courseList", component: <CourseList /> },
  { path: "/addCourse", component: <AddCourse /> },
  { path: "/edit-course/:courseId", component: <EditCourse /> },
  { path: "/view-course/:courseId", component: <ViewCourse /> },

  // //Common Course
  { path: "/commonCourseList", component: <CommonCourseList /> },
  { path: "/addCommonCourse", component: <AddCommonCourse /> },
  { path: "/viewCommonCourse/:id", component: <ViewCommonCourse /> },
  { path: "/editCommonCourse/:id", component: <EditCommonCourse /> },

  //Task
  { path: "/taskList", component: <Tasklist /> },
  { path: "/assignTask", component: <AssignTask /> },
  { path: "/editTask/:taskId", component: <EditTask /> },
  { path: "/myTasks", component: <TaskDataTable /> },
  { path: "/viewTask/:taskId", component: <ViewTask /> },

  //Intrested Candidates
  { path: "/intrestedCandidates", component: <IntrestedCandidates /> },

  //News and Articles
  { path: "/newsArticles", component: <ListNewsAndArticles /> },
  { path: "/add-news-article", component: <AddNewsAndArticle /> },
  { path: "/edit-news-article/:id", component: <EditNewsAndArticle /> },
  { path: "/news-and-articles", component: <ListNewsAndArticles /> },
  { path: "/news-and-articles/:id", component: <ViewArticle /> },

  //SEO
  { path: "/seo", component: <SeoDataTable /> },
  { path: "/add-seo", component: <AddSeo /> },
  { path: "/view-seo/:id", component: <ViewSeo /> },
  { path: "/edit-seo/:id", component: <EditSeo /> },
  // this route should be at the end of all other routes
  { path: "/collegeApplications", component: <CollegeApplicationList /> },
  { path: "/statePreferences", component: <StatePreferences /> },
  { path: "/countryPreferences", component: <CountryPreferences /> },
  { path: "/emailTemplate", component: <EmailTemplateDataTable /> },
  { path: "/addEmailTemplate", component: <AppAddEmailTemplate /> },
  { path: "/editEmailTemplate/:id", component: <EditEmailTemplate /> },
  { path: "/settings", component: <SiteConfig /> },

  // Policy
  { path: "/Policy", component: <Policy /> },
  { path: "/addPolicy", component: <AddPolicy /> },
  { path: "/editPolicy/:id", component: <EditPolicy /> },
  { path: "/viewPolicy/:id", component: <ViewPolicy /> },

  // School
  { path: "/schoolList", component: <SchoolDataTable /> },
  { path: "/addSchool", component: <AddSchool /> },
  { path: "/edit-school/:schoolCode", component: <EditSchool /> },
  { path: "/view-school/:schoolCode", component: <ViewSchool /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { userRoutes, authRoutes }
